const PREFIX = '@@workflow'

export const REQUEST = `${PREFIX}/REQUEST`
export const ERROR = `${PREFIX}/ERROR`

export const PATIENT_WORKFLOW = `${PREFIX}/PATIENT_WORKFLOW`
export const UPDATE_WORKFLOW = `${PREFIX}/UPDATE_WORKFLOW`
